import {BulkArchiveItemsResponse, BulkUnarchiveItemsResponse} from 'archive/ArchiveConstants';
import {
  SchemaFieldSelector,
  SchemaFieldSelectorOptionForUpdate,
  SchemaFieldSelectorOptionToUpdate,
} from 'schemas/SchemaFieldSelectorConstants';
import * as net from 'util/Net';

export interface SchemaFieldSelectorWithOptionToUpdate extends SchemaFieldSelector {
  schemaFieldSelectorOptionToUpdate?: SchemaFieldSelectorOptionToUpdate;
}

export interface SchemaFieldSelectorForUpdate {
  name?: string;
  schemaFieldSelectorOptions?: Array<SchemaFieldSelectorOptionForUpdate>;
  selectorOptionToUpdate?: SchemaFieldSelectorOptionToUpdate;
}

export interface SchemaFieldSelectorsByRegistryId {
  selectorsByRegistryId: {[registryId: string]: Array<SchemaFieldSelector>};
}

export default {
  create(data: {
    name: string;
    registryId: string;
    schemaFieldSelectorOptions: Array<SchemaFieldSelectorOptionForUpdate>;
  }): JQueryPromise<SchemaFieldSelector> {
    return net.postJSON({
      url: '/1/api/schema-field-selectors/',
      data,
    });
  },

  delete(selectorId: string): JQueryPromise<{}> {
    return net.delete_({
      url: `/1/api/schema-field-selectors/${selectorId}`,
    });
  },

  bulkArchive(ids: Array<string>, purpose: string): JQueryPromise<BulkArchiveItemsResponse> {
    return net.postJSON({
      url: '/1/api/schema-field-selectors:bulk-archive',
      data: {ids, purpose},
    });
  },

  bulkUnarchive(ids: Array<string>): JQueryPromise<BulkUnarchiveItemsResponse> {
    return net.postJSON({
      url: '/1/api/schema-field-selectors:bulk-unarchive',
      data: {ids},
    });
  },

  fetch(registryId: string | null): JQueryPromise<SchemaFieldSelectorsByRegistryId> {
    return net.getJSON('/1/api/schema-field-selectors/', {registryId});
  },

  update(
    selectorId: string,
    data: SchemaFieldSelectorForUpdate
  ): JQueryPromise<SchemaFieldSelectorWithOptionToUpdate> {
    return net.patchJSON({
      url: `/1/api/schema-field-selectors/${selectorId}`,
      data,
    });
  },
};
